import axios from "axios";

const axiosClient = axios.create();
axiosClient.defaults.baseURL = process.env.REACT_APP_BASE_URL;

axiosClient.defaults.timeout = 20000;

axiosClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.code === "ECONNABORTED") {
      err.message = "Server error. Please try again!";
    }

    return Promise.reject(err);
  }
);

export async function getRequest(url, varToken, payload) {
  const config = {
    headers: {
      authorization: "Bearer " + varToken,
    },
    params: payload,
  };

  return axiosClient.get(url, config);
}

export async function postRequest(url, varToken, payload) {
  const config = {
    headers: {
      authorization: "Bearer " + varToken,
    },
  };

  return axiosClient.post(url, payload, config);
}

export async function putRequest(url, varToken, payload) {
  const config = {
    headers: {
      authorization: "Bearer " + varToken,
    },
  };

  return axiosClient.put(url, payload, config);
}

export async function deleteRequest(url, varToken, payload, data) {
  const config = {
    headers: {
      authorization: "Bearer " + varToken,
    },
    params: payload,
    data,
  };

  return axiosClient.delete(url, config);
}

export function patchRequest(url, data, token) {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axiosClient.patch(url, data, config);
}
